// extracted by mini-css-extract-plugin
export default {"wrap":"Notice_wrap__dtf0U","topWrap":"Notice_topWrap__4nVF2"};